





























































import BaseComponent from '@/components/base-component.vue';
import BaseLogin from '@/components/login/base-login-page.vue';
import { errorHandling } from '@/helpers/errorHandling';
import { login } from '@/services/auth';
import {
  addLoginRemember,
  getLoginsRemember,
  getRedirectAfterLogin,
  isRememberOn,
  removeLoginRemember,
  setRememberOnOff
} from '@/services/session-data';
import { authenticateByFingerprint, isFingerprintAvailable } from '@/services/webauthn';
import {
  ERROR_CODE_LOGIN_INVALID,
  ERROR_CODE_UNAUTHORIZED_INVALID
} from '@/settings/consts/api-error';
import {
  MESSAGE_LOGIN_ERROR,
  MESSAGE_LOGIN_PASSWORD_ERROR,
  MESSAGE_LOGIN_UNAUTHORIZED_ERROR
} from '@/settings/consts/messages';
import { HOME_PATH } from '@/views/home/routes';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import RegisterFingerprintDialog from './register-fingerprint-dialog.vue';

@Component({
  components:{
    BaseLogin,
    RegisterFingerprintDialog
  }
})
export default class Login extends BaseComponent {
  private msg:string = null;
  remember = true;
  loginsRemember = null;
  userSearchInput = null;

  public form: any = {
    valid: false,
    rules: {
      username: [
        (v) =>  this.validUserEmpty(v) || 'Digite/Escolha o CPF ou o CRM',
        (v) => this.validUser(v) || 'Usuário inválido',
      ],
      password: [(v) => !!v || 'Digite a Senha'],
    },
  };

  validUserEmpty(v) {
    return (!!v || !!this.userSearchInput);
  }

  validUser(v) {
    return (!!v && !!v.value ) || (!!this.userSearchInput && !/[^A-Z|0-9|\.|\-]/gi.test(this.userSearchInput))
  }

  @Watch('userSearchInput') 
  onUserSearchInputChange() {
    this.$refs.form.validate();
  }

  public $refs!: {
    form: HTMLFormElement;
  };

  public setFocus(refName) {
    setTimeout(() => {
      let elem: any = this.$refs[refName];
      if (elem && elem.length) {
        elem[0].focus();
      }
    }, 100);
  }

  public user: any = {
    username: null,
    password: null,
  };

  public beforeMount(): void {
    this.loader.stop();
    this.toast.removeAll();
  }

  public validateBeforeSubmit(): void {
    if (!this.accessByPassword) {
      this.loginByBiometria();
      return;
    }
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.handleSubmit();
  }

  mounted() {
    if (getRedirectAfterLogin()) {
      this.msg = "Após efetuar o login, você será redirecionado para o link solicitado";
    } else {
      this.msg = null;
    }

    this.checkTemBiometria()
    this.loginsRemember = getLoginsRemember();
    this.remember = isRememberOn();
  }

  private handleSubmit() {
    this.loader.start('Validando dados...');

    const onError = (error) => {
      this.loader.stop();
      let instance = this;
      if (error && error.data && error.data.inactivity) {
        this.dialog.show(
          'alert',
          'Usuário suspenso',
          'Seu acesso foi suspenso por falta de atividade nas últimas semanas. Deseja efetuar o desbloqueio agora?',
          'Sim',
           () => { 
              sessionStorage.setItem('usernameUnblock', instance.user.username);
              instance.$router.push('/desbloquear');
            },
          'Não',
          null,
        );
        return;
      }

      const errorMessages = {
        default: MESSAGE_LOGIN_ERROR,
        [ERROR_CODE_LOGIN_INVALID]: MESSAGE_LOGIN_PASSWORD_ERROR,
        [ERROR_CODE_UNAUTHORIZED_INVALID]: MESSAGE_LOGIN_UNAUTHORIZED_ERROR,
      };

      const message = errorHandling(error, errorMessages);

      this.dialog.show(
        'alert',
        'Erro ao realizar o login',
        message,
        'Ok',
        null,
        '',
        null,
      );
    };

    const user = this.getUsername();

    login(user, this.user.password).subscribe(() => {
      this.loader.stop();
      setRememberOnOff(this.remember);
      if (this.remember) {
        addLoginRemember(user);
      }
      if (this.hasFingerprintAvailable) {
        this.showRegisterFingerprintDialog();
      } else {
        this.$router.push(HOME_PATH);
      }
    }, onError);
  }

  
  accessByPassword = false;
  hasFingerprintAvailable = false;
  showModalRegisterFingerprint = false;

  checkTemBiometria() {
    isFingerprintAvailable().then(r => {
      this.hasFingerprintAvailable = r.valueOf();
      this.accessByPassword = !r.valueOf();
    });
  }

  loginByBiometria() {
    setTimeout(() => {
      const user = this.getUsername();
      this.loader.start('Processando ... ')
      authenticateByFingerprint(user).then(r => {
        setRememberOnOff(this.remember);
        if (this.remember) {
          addLoginRemember(user);
        }
        this.loader.stop();      
        this.$router.push(HOME_PATH);
      }).catch(error => {
        this.loader.stop();
        this.accessByPassword = true;
        setTimeout(() => {
          this.$refs['password'].focus();        
        }, 100);
      })      
    }, 200);
  }

  getUsername() {
    if(!this.user.username) {
      return null;
    }
    let username = this.user.username
    if (username instanceof Object && !!username.value) {
      username = username.value;
    }

     return username.replace(/\.|\-/g, '');
  }

  onUsernameChange() {
    this.checkTemBiometria();
  }

  showRegisterFingerprintDialog() {
    this.showModalRegisterFingerprint = true;
  }

  onFingerprintDialogClose() {
    this.showModalRegisterFingerprint = false;
    this.$router.push(HOME_PATH);
  }

  delUsernameRememberConfirm(item) {
    let instance = this;
    this.dialog.show(
      'alert', 
      'Remover usuário', 
      'Deseja remover o usuário ' + item.label + '?',
      'Remover',
      () => {
        instance.loginsRemember = removeLoginRemember(item.value);
        this.user.username = null;
      },
      'Cancelar',
      () => {

      }
    )
  }
}
